/**
 * This is the Custom checkbox widget
 *
 * optional @prop widgetId {String} widget ID
 ÷ optional @prop type {string} valid values normal|small, default value is normal
 * optional @prop isChecked {Bool} the checkbox is checked
 * optional @prop forceHover {Bool} the checkbox is force hovered
 * optional @prop isDisabled {Bool} tho checkbox is disabled
 * optional @prop isPartiallyChecked {Bool} the checkbox is partially checked
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { omit } from 'lodash';
import displayName from 'component-lib/displayName';

import styles from './CustomCheckbox.scss';

export default class CustomCheckbox extends Component {
    static displayName = displayName('Widgets/CustomCheckbox');

    static propTypes = {
        widgetId: PropTypes.string,
        type: PropTypes.oneOf(['normal', 'small']),
        isChecked: PropTypes.bool,
        forceHover: PropTypes.bool,
        isDisabled: PropTypes.bool,
        isPartiallyChecked: PropTypes.bool,
        className: PropTypes.string,
    };

    static defaultProps = {
        className: '',
        widgetId: '',
        type: 'normal',
        isChecked: false,
        forceHover: false,
        isPartiallyChecked: false,
        isDisabled: false,
    };

    render() {
        const { forceHover, type, isChecked, isPartiallyChecked, isDisabled } = this.props;

        const widgetProps = omit(this.props, [
            'isChecked',
            'type',
            'styleName',
            'styles',
            'forceHover',
            'isPartiallyChecked',
            'isDisabled',
            'widgetId',
            'isChecked',
        ]);
        let className = `checkbox-${type}`;

        if (isChecked) {
            className += '-checked';
        } else if (forceHover) {
            className += '-force-hover';
        }

        // The partial and disabled states must overwrite all the preset rules if present
        if (isPartiallyChecked) {
            className = `checkbox-${type}-partial`;
        }

        if (isDisabled) {
            className = `checkbox-${type}-disabled`;
        }

        className = styles[className];

        if (this.props.className) {
            className += ` ${this.props.className}`;
        }

        return (
            <span
                {...widgetProps}
                data-type={type}
                ref={(c) => {
                    this.customCheckbox = c;
                }}
                className={className}
                data-checked={isChecked}
                data-partially-checked={isPartiallyChecked}
                data-disabled={isDisabled}
            />
        );
    }
}
